/**
 * Created by Administrator on 2017/7/18 0018.
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import {GRAY_BODY, WHITE_BODY} from 'components/api/index-web';
import {setTitleHack} from '../utils/utils';

Vue.use(VueRouter);

// 支付宝-码上付
export const AliScanPay = () => import(/* webpackChunkName: "ali-scan-pay" */ 'components/aliScanPay/AliScanPay.vue');
export const AlipayWithoutOrder = () => import(/* webpackChunkName: "ali-scan-pay" */ 'components/aliScanPay/AlipayWithOutOrder.vue');
export const AliScanOrderDetail = () => import(/* webpackChunkName: "ali-scan-pay" */ 'components/aliScanPay/AliScanOrderDetail.vue');
export const AliScanError = () => import(/* webpackChunkName: "ali-scan-pay" */ 'components/aliScanPay/AliError.vue');

// 订单中心
export const orderCenter = () => import(/* webpackChunkName: "order-center" */ 'components/ordercenter/OrderCenter.vue');
export const allOrders = () => import(/* webpackChunkName: "order-center" */ 'components/allorders/AllOrders.vue');
export const orderDetail = () => import(/* webpackChunkName: "order-center" */ 'components/orderdetail/OrderDetail.vue');

// 点餐
export const goods = () => import('components/goods/Goods.vue');
export const order = () => import(/* webpackChunkName: "dinner" */ 'components/order/Order.vue');
export const pay = () => import(/* webpackChunkName: "dinner" */ 'components/pay/Pay.vue');
export const payResult = () => import(/* webpackChunkName: "dinner" */ 'components/pay/PayResult.vue');

// 位置相关
export const stores = () => import('components/store/Stores.vue');
export const navigation = () => import('components/store/Navigation.vue');
export const regist = () => import('components/regist/Regist.vue');

// 其他
const distribution = () => import('components/distribution/Distribution.vue');
const errorPage = () => import('components/common/ErrorPage.vue');
const errorPage2 = () => import('components/common/ErrorPage2.vue');
const aliScan = () => import('components/common/AliScan.vue');

// 微信扫码点餐首页
export const HomeWechatScan = () => import('components/home/HomeWechatScan');
// 套餐详情
export const SuitDetail = () => import('components/fooddetail/SuitDetail');
// 投诉建议
export const Feedback = () => import(/* webpackChunkName: "feedback" */ 'components/feedback/Feedback.vue');


export default new VueRouter({
  /* scrollBehavior: () => ({ // 滚动条滚动的行为，不加这个默认就会记忆原来滚动条的位置
   y: 0
   }), */
  routes: [{
    path: '/goods',
    name: 'goods',
    component: goods,
    meta: {
      title: '点餐'
    },
    beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = WHITE_BODY;
      setTitleHack(to.meta.title);
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/regist',
    component: regist
  }, {
    path: '/distribution',   // 选择就餐时间/就餐人数
    name: 'distribution',
    component: distribution,
    meta: {
      title: ''
    }
  }, {
    path: '/pay/:orderId',
    name: 'pay',
    component: pay,
    beforeEnter(to, from, next) {
      setTitleHack(to.meta.title);
      window.document.body.style.backgroundColor = '#f2f5fa';
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    },
    meta: {
      keep: true,
      title: '订单支付',
      allowBack: false
    }
  }, {
    path: '/payResult/:orderId/:branchId',
    name: 'payResult',
    component: payResult,
    meta: {
      title: '支付完成'
    },
    beforeEnter(to, from, next) {
      setTitleHack(to.meta.title);
      window.document.body.style.backgroundColor = '#f2f5fa';
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/order',
    name: 'order',
    component: order,
    meta: {
      keep: true,
      title: '确认订单'
    }
  }, {
    path: '/orderCenter',
    component: orderCenter,
    children: [{
      path: '/',
      redirect: 'allOrders'
    }, {
      path: 'allOrders',
      name: 'allOrders',
      component: allOrders,
      meta: {
        keep: true,
        title: '全部订单'
      },
      beforeEnter(to, from, next) {
        setTitleHack(to.meta.title);
        window.document.body.style.backgroundColor = GRAY_BODY;
        next();
      },
      beforeLeave(to, from, next) {
        window.document.body.style.backgroundColor = '';
        next();
      }
    }],
    beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = GRAY_BODY;
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/orderDetail/:orderId/:branchId',
    name: 'orderDetail',
    component: orderDetail,
    meta: {
      keep: true,
      title: '订单信息'
    },
    beforeEnter(to, from, next) {
      setTitleHack(to.meta.title);
      window.document.body.style.backgroundColor = GRAY_BODY;
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/stores',
    name: 'stores',
    component: stores,
    meta: {
      title: '门店列表'
    },
    beforeEnter(to, from, next) {
      setTitleHack(to.meta.title);
      next();
    }
  }, {
    path: '/navigation',
    name: 'navigation',
    component: navigation,
    meta: {
      title: '导航',
      keep: true
    },
    beforeEnter(to, from, next) {
      setTitleHack(to.meta.title);
      next();
    }
  }, {
    path: '/error',
    name: 'error',
    component: errorPage,
    beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = GRAY_BODY;
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/error2',
    name: 'error2',
    component: errorPage2,
    beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = GRAY_BODY;
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/aliScan',   // 支付宝扫一扫
    name: 'aliScan',
    component: aliScan,
    beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = GRAY_BODY;
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/feedback',
    name: 'feedback',
    component: Feedback,
    meta: {
      title: '意见反馈'
    },
    beforeEnter(to, from, next) {
      setTitleHack(to.meta.title);
      window.document.body.style.backgroundColor = '#f2f5fa';
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/aliScanPay',   // 支付宝码上付
    name: 'aliScanPay',
    component: AliScanPay,
    meta: {
      title: '买单',
      keep: true
    },
    beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = GRAY_BODY;
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/alipayWithOutOrder',   // 支付宝码上付兜底支付页面
    name: 'alipayWithOutOrder',
    component: AlipayWithoutOrder,
    meta: {
      title: '买单'
    },
    beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = GRAY_BODY;
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/aliError',  // 支付宝码上付兜底错误页面
    name: 'aliError',
    component: AliScanError,
    meta: {
      title: '买单'
    },
    beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = GRAY_BODY;
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/aliScanOrderDetail',  // 支付宝card位订单详情
    name: 'aliScanOrderDetail',
    component: AliScanOrderDetail,
    meta: {
      title: '订单信息'
    },
    beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = GRAY_BODY;
      next();
    },
    beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/home',  // 微信扫码点餐首页
    name: 'home',
    component: HomeWechatScan,
    meta: {
      title: '欢迎光临',
      keep: true
    }
  }, {
    path: '/suitDetail',  // 套餐详情页
    name: 'suitDetail',
    component: SuitDetail,
    meta: {
      title: '套餐详情',
      keep: true
    }
  }],
  linkActiveClass: 'active'
});



// WEBPACK FOOTER //
// ./src/config/router.config.js